var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "con-btn" },
    [
      _c(
        "div",
        {
          staticClass: "breadcrumb-layout",
          staticStyle: { padding: "10px 0" }
        },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("合同管理")
              ]),
              _vm._v(" "),
              _vm.operate == "edit"
                ? _c(
                    "div",
                    [
                      _c("el-breadcrumb-item", [_vm._v("代理编辑集成采购合同")])
                    ],
                    1
                  )
                : _vm.operate == "chakan"
                ? _c(
                    "div",
                    [
                      _c("el-breadcrumb-item", [_vm._v("代理查看集成采购合同")])
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("el-breadcrumb-item", [_vm._v("代理添加集成采购合同")])
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("swb-register-comn-seller-contract", {
        ref: "swb_register_comn_seller_contract",
        attrs: {
          contractId: _vm.contractId,
          operate: _vm.operate,
          contractType: _vm.contractType,
          srcMerchant: _vm.srcMerchant,
          sndMerchant: _vm.sndMerchant
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03b34fe4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b34fe4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/RegisterIntegPurchContract.vue
// module id = 1810
// module chunks = 1